import {
  Component,
  effect,
  forwardRef,
  input,
  signal,
  WritableSignal,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { AppStateService } from '@shared/services';
import { MenuRadioItemInterface, MenuSelectComponent } from '@shared/ui/menu';

@Component({
  selector: 'shared-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.css'],
  imports: [ReactiveFormsModule, MenuSelectComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormSelectComponent),
      multi: true,
    },
  ],
})
export class FormSelectComponent implements ControlValueAccessor {
  options = input.required<MenuRadioItemInterface[]>();

  selectedValue = input<string | null>(null);

  placeholder = input<string>();

  selectedItem: WritableSignal<MenuRadioItemInterface | null> = signal(null);

  disabledWhileSelect = false;

  onChanged: any = (value: any) => {
    console.log('initialization');
  };

  onTouched: any = () => {
    console.log('initialization');
  };

  constructor(protected appStateService: AppStateService) {
    effect(() => {
      if (this.selectedValue()) {
        this.changeSelectedItem(this.selectedValue()!);
      }
    });
  }

  changeSelectedItem(newItemValue: string): void {
    const newItem = this.options().find(
      (option) => option.value === newItemValue,
    );
    if (newItem) {
      this.selectedItem.set(newItem);
      this.onChanged(newItem);
      this.onTouched();
    }
  }

  writeValue(value: MenuRadioItemInterface): void {
    this.selectedItem.set(value);
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabledWhileSelect = isDisabled;
  }
}
